import { colors } from '@insurancemenu/imenu-components-lib';
import { WarningFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import clsx from 'clsx';
import { createStyles } from './styles';

export interface ErrorMessageProps {
  error: string | JSX.Element;
  className?: string;
}

const ErrorMessage = ({ error, className }: ErrorMessageProps): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={clsx(classes.errorMessage, className)}>
      <WarningFilled color={colors.red[500]} height="1.2rem" className={classes.validationIcon} />
      <span>{error}</span>
    </div>
  );
};

export default ErrorMessage;
